export interface MetaSyncResponse {
      id?: string;
      code?: string;
      name?: string;
      description?: string;
      version?: number;
      viewmode?: string;
      dataFlow?: string;
      moduleCode?: string;
      transType?: string;
      placement?: string;
      actions?: string;
      taxConfig?: string;
      entityId?: string;
      isPublished?: boolean;
      uiSchema: string;
      fields: MetaFieldDtoo[];
}

export interface JsonSchemaPayload {
      entitySchema: string;
      uiSchema: string;
}

export interface MetaFieldDtoo {
      [key: string]: any;
      id?: string;
      entityId: string;
      fieldId: string;
      name: string;
      label?: string;
      type: string;
      category: string;
      parentField?: string;
      isRequired: boolean;
      inputType?: string;
      placeholder?: string;

      // JSONB / Stringified JSON fields
      validators?: string;
      options?: string;
      dataSource?: string;
      events?: string;
      reference?: string;
      visibility?: string;
      softMax?: string;
      dependsOn?: string;
      state?: string;

      computedExpression?: string;
      displaySource?: string;
      requiredWhen?: string;
      seq: number;
      createdAt?: Date;
      entityName?: string;
}

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
      providedIn: 'root'
})
export class MetaSyncService {
      // Base URL updated to match your provided local port and controller route
      private baseUrl = `${environment.apiUrl}/api/v1/meta-sync`;
      private apiUrl = `${environment.apiUrl}/api/sys/admin/entity`;

      constructor(private http: HttpClient) { }

      addField(field: MetaFieldDtoo): Observable<any> {
            return this.http.post(`${this.baseUrl}/add`, field);
      }

      // deleteField(entityId: string, fieldName: string): Observable<any> {
      //       return this.http.delete(`${this.baseUrl}/${entityId}/delete/${fieldName}`);
      // }

      /**
       * GET: Fetch all entities and their synchronized fields
       * Maps to [HttpGet("all")]
       */
      getAllSyncData(): Observable<MetaSyncResponse[]> {
            return this.http.get<MetaSyncResponse[]>(`${this.baseUrl}/all`);
      }

      /**
       * POST: Syncs the UI Designer JSON and regenerates Meta Fields
       * Maps to [HttpPost("ui/sync/{entityId}")]
       * @param entityId The GUID of the entity
       * @param uiSchema The raw JSON string of the form layout
       */
      syncUiToFields(entityId: string, entitySchema: string, uiSchema: string): Observable<any> {
            const payload: JsonSchemaPayload = { entitySchema : entitySchema, uiSchema: uiSchema };
            return this.http.post(`${this.baseUrl}/ui/sync/${entityId}`, payload);
      }

      /**
       * PUT: Updates a specific field row and patches the UI JSON
       * Maps to [HttpPut("field/sync")]
       * @param dto The full MetaField data transfer object
       */
      syncFieldToUi(dto: MetaFieldDtoo): Observable<any> {
            return this.http.put(`${this.baseUrl}/field/sync`, dto);
      }

      createEntity(entityData: any): Observable<any> {
            // This matches your [FromBody] JsonObject body in C#
            return this.http.post<any>(this.apiUrl, entityData);
      }

      publishEntity(entityId: string): Observable<any> {
            // Assuming a simple POST to a publish endpoint; adjust as needed for your API design
            return this.http.post(`${this.baseUrl}/publish/${entityId}`, {});
      }

      hardDeleteEntity(entityId: string): Observable<any> {
  // Pointing to the new hard-delete endpoint created in the .NET Controller
  // Ensure the URL matches your C# Route (e.g., api/v1/meta-sync/entity-wipe/{id})
  return this.http.delete(`${this.baseUrl}/entity-wipe/${entityId}`);
}

deleteField(entityId: string, fieldName: string) {
  // Matches the [HttpDelete("entities/{entityId}/fields/{fieldName}")] pattern
  return this.http.delete(`${this.baseUrl}/entities/${entityId}/fields/${fieldName}`);
}
}